import { Component, Input, Output, OnInit, EventEmitter, ViewChildren, QueryList, ElementRef, AfterViewInit } from '@angular/core';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: false
})
export class FilterComponent implements OnInit, AfterViewInit {
  panelFilter: boolean = false;
  columnsNameDataTable = [];
  source = "";

  @ViewChildren('inputRef') inputElements!: QueryList<ElementRef<HTMLInputElement>>;
  constructor(private localStorageService: LocalStorageService) { }

  ngOnInit(): void {

    console.log("filter component ----->", this.source);
    this.localStorageService.getColumnsFilter.subscribe(columns => {
      console.log("columns filters --->", columns);
      this.localStorageService.getMenuSelectedObs.subscribe(menu => {
        console.log("menu ---->", menu)
        if (menu) {
          const { subDomainJO } = menu;
          this.source = subDomainJO;
        }
        this.columnsNameDataTable = columns;
      })
    })

  }

  ngAfterViewInit(): void {
    this.lastFilter();
  }

  lastFilter() {
    this.localStorageService.onFilterPreviewReset();
    if (this.source !== this.localStorageService.getSourcePrevius) {
      this.localStorageService.setFilter = undefined;
      this.generateInputElements();
    } else {
      this.generateInputElements();
    }
  }

  applyFilterEmit(event: any, columVar: string) {
    const body = {
      event,
      columVar
    }
    this.localStorageService.onFilterPreview(body);
  }

  generateInputElements() {
    const filterStorage = this.localStorageService.getFilter;
    this.inputElements.forEach((element, index) => {
      const filterValue = filterStorage ? filterStorage[element.nativeElement.id] : "";
      if (filterValue) {
        element.nativeElement.value = filterValue;
      }
    });
  }

}
